import { StrictMode } from 'react';

import { createRoot } from 'react-dom/client';

import '@/styles/globals.css';
import App from '@/App';
import { RootErrorBoundary } from '@/components/error/RootErrorBoundary';
import { initChunkLoadAutoReload } from '@/lib/chunk-load-recovery';
import { evictExpiredDrafts } from '@/lib/form-draft';
import { queryClient } from '@/lib/query-client';
import { initRuntimeReleaseGuard } from '@/lib/runtime-release-guard';
import { startOwnerReport } from '@/pages/owner-report/ownerLaunch';
import { initFrontendErrorSink } from '@/telemetry/errorSink';
import { initProductAnalytics } from '@/telemetry/productAnalytics';

const rootElement = document.getElementById('root');

if (!rootElement) {
  throw new Error('Root element not found');
}

evictExpiredDrafts();
initChunkLoadAutoReload();
initRuntimeReleaseGuard();
initFrontendErrorSink();
initProductAnalytics();
// The owners' Mini App reads its report while the page's code still loads.
startOwnerReport(queryClient);

createRoot(rootElement).render(
  <StrictMode>
    <RootErrorBoundary>
      <App />
    </RootErrorBoundary>
  </StrictMode>,
);
